import { useSelector } from 'react-redux';
import { thoughtspot } from 'config';
import { cancelFunctions } from 'utils/cancelFunctions';
import { initialiseThoughtspot } from 'utils/thoughtspotInit';
import LiveboardVisuals from 'components/common/LiveboardVisuals';
import { Store } from 'components/common/types/Store.types';
import {
  filterByMarket,
  thoughtspotLiveboardStyles,
  labsReportVisibleActions,
  TABS_STYLES,
} from '../LabsReportDropdown/utils';

const POPLiveMonitoring: React.FC = () => {
  const { localeCode, marketId } = useSelector((state: Store) => state.publisher.configuration);

  initialiseThoughtspot(localeCode, cancelFunctions);

  return (
    <div className={TABS_STYLES}>
      <LiveboardVisuals
        liveboardId={thoughtspot.popLiveMonitoringLiveboardId}
        customizations={thoughtspotLiveboardStyles}
        visibleActions={labsReportVisibleActions}
        filterByOptions={[filterByMarket(marketId)]}
      />
    </div>
  );
};

export default POPLiveMonitoring;
